module.exports = __webpack_public_path__ + "static/media/liquids.2cd5e2c0.png";